/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Oauth_Error_DenyInputs */



/**
* | output |
* | --- |
* | "Failed to deny" |
*
* @param {Oauth_Error_DenyInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const oauth_error_deny = /** @type {((inputs?: Oauth_Error_DenyInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Oauth_Error_DenyInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Échec du refus")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error al denegar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Falha ao negar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile negare")
	return /** @type {LocalizedString} */ ("Failed to deny")
});